import { render } from "./LayoutDetail.vue?vue&type=template&id=2aca803f"
import script from "./LayoutDetail.vue?vue&type=script&lang=js"
export * from "./LayoutDetail.vue?vue&type=script&lang=js"

import exportComponent from "/var/jenkins_home/workspace/00-client-web(prod)/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__